<kh-img path="/spinner-green.gif" class="spinner-green LoadingIconWhite"></kh-img>